import GROW_2529_EXPERIMENT_TOOLTIP_COPY from '~pricing/experiments/grow_2529_forms/copy/experimentTooltipCopy';
import GROW_2792_EXPERIMENT_TOOLTIP_COPY from '~pricing/experiments/grow_2792_pnp_refresh_v1/copy/experimentTooltipCopy';

const EXPERIMENT_TOOLTIP_COPY = {
  ...GROW_2529_EXPERIMENT_TOOLTIP_COPY,
  ...GROW_2792_EXPERIMENT_TOOLTIP_COPY,
};

export default EXPERIMENT_TOOLTIP_COPY;
